<style lang="scss">
.calculation {
  &-content {
    min-height: 32rem;
    padding: 3rem;
    background-color: color(primary);
    color: white;
  }

  &-footer {
    padding: 3rem;
    padding-right: 6rem;
    font-size: 5rem;
    font-weight: bold;
    color: color(blue-dark);
    background-color: white;
  }
}
</style>

<template>
  <div class="calculation">
    <div class="calculation-content">
      <calculation-input-row
        v-for="(input, index) in inputs"
        :key="index"
        :name="input.name"
        :value="input.value"
        :unit="input.unit"
      />
    </div>
    <div class="calculation-footer">
      <v-row>
        <v-col
          :size="12"
          class="flex justify-between"
        >
          <span>=</span>
          <span>&euro;{{ result | formatNumbers }}</span>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import CalculationInputRow from '@/views/Home/Valorization/Calculations/CalculationInputRow';

export default {
  name: 'Calculation',
  components: {
    CalculationInputRow,
  },
  props: {
    inputs: {
      type: Array,
      default() {
        return [];
      },
    },
    result: {
      type: Number,
      default: null,
    },
  },
};
</script>
